<bic-popup (close)="close()" [hasBackdrop]="true" title="Konto löschen?" customClass="w-[560px]">
  <div bicPopupContent class="flex flex-col">
    <span class="font-normal">Ihr Konto wird deaktiviert und anschließend gelöscht.<br><br>
      <span class="font-medium">Hinweis:</span> Ihre Daten werden in 30 Tagen gelöscht. Innerhalb dieses Zeitraums können Sie sich jederzeit wieder anmelden und Ihr Konto selbst reaktivieren.</span>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    <bic-button (onClick)="close()" buttonType="white" matDialogClose>Abbrechen</bic-button>
    <bic-button (onClick)="delete()" buttonType="red">Löschen</bic-button>
  </div>
</bic-popup>
